import React, { useState } from 'react';
import { login } from './auth';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = await login(email, password);

            if (data.success) {
                toast.success('Login successfully!');
                const userRole = data.role;

                if (userRole === 'admin') {
                    navigate('/admin/dashboard');
                } else {
                    toast.error('Invalid role. Contact admin.');
                }
            } else {
                toast.error(data.message || 'Login failed');
            }
        } catch (error) {
            toast.error(error.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    // ----- inline styles -----
    const containerStyle = {
        minHeight: '100vh',
        backgroundColor: '#f0f9ff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const cardStyle = {
        maxWidth: '400px',
        width: '100%',
        background: 'white',
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
    };

    const titleStyle = {
        textAlign: 'center',
        marginBottom: '1.5rem',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#0b2b3b',
    };

    const labelStyle = {
        display: 'block',
        marginBottom: '0.25rem',
        fontWeight: '600',
        fontSize: '0.9rem',
        color: '#1e293b',
    };

    const inputGroupStyle = {
        display: 'flex',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        overflow: 'hidden',
        background: 'white',
    };

    const inputGroupTextStyle = {
        padding: '0.5rem 0.75rem',
        background: '#f8fafc',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        color: '#64748b',
    };

    const inputStyle = {
        flex: 1,
        padding: '0.5rem 0.75rem',
        border: 'none',
        outline: 'none',
        fontSize: '0.9rem',
    };

    const buttonStyle = {
        width: '100%',
        padding: '0.6rem',
        background: '#0b2b3b',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'background 0.2s, transform 0.1s',
        marginTop: '0.5rem',
    };

    const buttonHoverStyle = {
        background: '#1f5068',
    };

    const buttonDisabledStyle = {
        opacity: 0.6,
        cursor: 'not-allowed',
    };

    // State for hover effect
    const [isHovered, setIsHovered] = useState(false);

    const getButtonStyle = () => {
        let style = { ...buttonStyle };
        if (loading) {
            style = { ...style, ...buttonDisabledStyle };
        }
        if (isHovered && !loading) {
            style = { ...style, ...buttonHoverStyle };
        }
        return style;
    };

    return (
        <>
            <div style={containerStyle}>
                <div style={cardStyle}>
                    <div style={titleStyle}>Venkatadri Seva Trust</div>

                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={labelStyle}>Email Address</label>
                            <div style={inputGroupStyle}>
                                <span style={inputGroupTextStyle}>
                                    <i className="fas fa-envelope"></i>
                                </span>
                                <input
                                    type="email"
                                    style={inputStyle}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                    required
                                />
                            </div>
                        </div>

                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={labelStyle}>Password</label>
                            <div style={inputGroupStyle}>
                                <span style={inputGroupTextStyle}>
                                    <i className="fas fa-lock"></i>
                                </span>
                                <input
                                    type="password"
                                    style={inputStyle}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter password"
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            style={getButtonStyle()}
                            disabled={loading}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            {loading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin me-2"></i> Logging in...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-sign-in-alt me-2"></i> Login
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default Login;